const initialState = {
    data: [],
    chartData: {},
    pieChartData: {},
    managerChartData: {},
    donorChartData: {},
    piechartOptions: {},
    donorChart: {},
    donorTableData:[],

   
  };
  
  const DashboardReducers = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
      case 'FETCH_CHART_DATA_SUCCESS':
        return {...state,chartData: action.payload.chartData,chartOptions: action.payload.chartOptions};
      case 'FETCH_PIE_CHART_DATA_SUCCESS':
        return {...state,pieChartData: action.payload.pieChartData,piechartOptions: action.payload.piechartOptions};
      case 'FETCH_Donor_CHART_DATA_SUCCESS':
        return {...state,donorChartData: action.payload.donorChartData,donorChart: action.payload.donorrchartOptions};
        case 'FETCH_Donor_Table_CHART_DATA_SUCCESS':
            return { ...state, donorTableData: action.payload.donorTableData };
            case 'FETCH_Donor_Table_CHART_DATA_SUCCESS':
            return { ...state, donorTableData: action.payload.donorTableData };
      default:
        return state;
  
      
    }
  };
  
  export default DashboardReducers;
  
  